import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../helpers/ErrorHelper';
import { useAuth } from '../../context/AuthContext';
import { tableCustomLoader } from '../../helpers/StyleHelper';
import dateFormat from "dateformat";
import DataTable, { createTheme } from 'react-data-table-component';
import { useTheme } from '../../context/ThemeContext';
import { invoiceAmount, invoiceStatus, formatInvoiceClientLabel } from '../../helpers/InvoiceHelper';
import { Link } from 'react-router-dom';
import InvoiceList from '../skeletons/InvoiceList';
import { useFinancialYear } from '../../context/FinancialYearContext';
import { getCmsDataTableStyles } from "../../helpers/DataTableStyles";

const InvoiceTables = ({
    data,
    setData,
    loading,
    setLoading,
    totalRows,
    setTotalRows,
    page,
    setPage,
    limit,
    setLimit,
    fetchInvoices,
    openDeleteInvoiceModal,
    curr_client_id,   // ✅ added
}) => {

    const { financialYear } = useFinancialYear();
    const { theme, toggleTheme } = useTheme();
    const { state } = useAuth(); 
    let user_data = state.user_data;

    const CustomLoader = () => (
        <InvoiceList/>
    );

    const handlePageChange = (nextPage) => {
        setPage(nextPage);
    };

    const handleLimitChange = (newLimit, currentPage) => {
        setLimit(newLimit);
        setPage(currentPage);
    };

    useEffect(() => {
        fetchInvoices(limit, page, curr_client_id);
    }, [financialYear, curr_client_id, fetchInvoices, limit, page]);

    const columns = [
        {
            name: "#",
            selector: (row, index) => <div>{((page-1)*limit)+index+1}.</div>,
            width: "68px",
            minWidth: "68px",
            maxWidth: "76px",
        },
        {
            name: "Client",
            selector: (row) => <div>{formatInvoiceClientLabel(row)}</div>,
            minWidth: "200px",
            grow: 3,
            wrap: true,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            },
        },
        {
            name: "Invoice ID",
            selector: (row) => <Link to={`/invoices/${row.invoice_unique_id}/edit`} style={{color: '#845adf'}}>{row.invoice_number}</Link>,
            minWidth: "120px",
            grow: 2,
            wrap: true,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            },
        },
        {
            name: "Issued Date",
            selector: (row) => dateFormat(row.invoice_bill_date, "dd mmm yyyy"),
            sortable: true, // ✅ enable sorting
            minWidth: "108px",
        },
        {
            name: "Amount",
            selector: (row) => invoiceAmount(row.invoice_type, row.invoice_amount),
            sortable: true, // ✅ enable sorting
            minWidth: "100px",
        },
        // {
        //     name: "Status",
        //     selector: (row) => invoiceStatus(row.invoice_status),
        //     width: '100px'
        // },
        {
            name: "Due Date",
            selector: (row) => dateFormat(row.invoice_due_date, "dd mmm yyyy"),
            sortable: true, // ✅ enable sorting
            minWidth: "108px",
        },
        {
            name : "Invoice Month",
            selector: (row) => row.invoice_month,
            sortable: true, // ✅ enable sorting
            minWidth: "120px",
            grow: 1,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            },
        },
        {
            name: "Action",
            cell: row => (
                <div className="hstack gap-1 justify-content-center flex-nowrap fs-15">
                    <Link
                        to={`/invoices/${row.invoice_unique_id}/edit`}
                        className="btn btn-icon btn-sm btn-info"
                        title="Edit"
                    >
                        <i className="bx bxs-edit"></i>
                    </Link>
                    <button
                        type="button"
                        className="btn btn-icon btn-sm btn-danger"
                        title="Delete"
                        onClick={() => openDeleteInvoiceModal(row)}
                    >
                        <i className="bx bxs-trash"></i>
                    </button>
                </div>
            ),
            width: "88px",
            minWidth: "88px",
            maxWidth: "88px",
            style: {
                whiteSpace: "nowrap",
            },
        }
    ];

    createTheme('dark', {
        text: {
          primary: '#a2a3a4',
          secondary: '#2aa198',
        },
        background: {
          default: '#252729',
        },
        context: {
          background: '#cb4b16',
          text: '#a2a3a4',
        },
        divider: {
          default: '#073642',
        },
        action: {
          button: 'rgba(0,0,0,.54)',
          hover: 'rgba(0,0,0,.08)',
          disabled: 'rgba(0,0,0,.12)',
        },
    });

    return (
        <DataTable 
            title={`Manage Invoices`} 
            columns={columns} 
            data={data} 
            pagination 
            paginationServer 
            paginationTotalRows={totalRows} 
            onChangeRowsPerPage={handleLimitChange} 
            onChangePage={handlePageChange} 
            progressPending={loading} 
            progressComponent={<CustomLoader />} 
            highlightOnHover
            paginationPerPage={10}  // default page size
            paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
            theme={`${theme==='light' ? 'light' : 'dark'}`}
            customStyles={getCmsDataTableStyles(theme)}
    />
    );
};    

export default InvoiceTables;    